import React, { useState, useEffect, useCallback, memo, useRef } from 'react';
import { getFirestore, collection, query, getDocs, doc, getDoc, setDoc, Timestamp } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { getAuth } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import swal from 'sweetalert';
import Table from 'react-bootstrap/Table'; 

function AssetRegisterComp() {

    const db = getFirestore(app);
    const auth = getAuth();
    const [modalShowUp, setModalShowUp] = useState(false);
    const [branchesList, setBranchesList] = useState([]);
    const [requiLists, setRequiLists] = useState([]);
    const [billsList, setBillsList] = useState([]);
    const [paymentModalShow, setPaymentModalShow] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState('');
    const [loading, setLoading] = useState(true);
    const [branchMapping, setBranchMapping] = useState({});


    useEffect(() => {
        const fetchBranches = async () => {
            const q = query(collection(db, 'Branches'));
            const querySnapshot = await getDocs(q);
            const branches = [];
            const mapping = {};
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                branches.push({ id: doc.id, ...data });
                mapping[doc.id] = data.branchName;
            });
            setBranchesList(branches);
            setBranchMapping(mapping);
        };
        fetchBranches();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const q = query(collection(db, 'AssetRegister'));
            const querySnapshot = await getDocs(q);
            const vendors = [];
            querySnapshot.forEach((doc) => {
                vendors.push({ id: doc.id, ...doc.data() });
            });
            setRequiLists(vendors); 
        };
        fetchData();
    }, []);


    function MyUpdateModal(props) {
        return (
            <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add an Asset
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Select a Campus</Form.Label>
                        <Form.Select aria-label="Default select example" ref={selectedCampus} >
                            {branchesList.map((vendor) => (
                                <option key={vendor.id} value={vendor.docID}>{vendor.branchName}</option>
                            ))}
                             <option value="General">General</option>
                        </Form.Select> 
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Asset Name</Form.Label>
                        <Form.Control type="text"  ref={assetName}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Category</Form.Label>
                        <Form.Select aria-label="Default select example" ref={assetCategory} >
                            <option value="IT & Electronics">IT & Electronics</option>
                            <option value="Furniture & Fixtures">Furniture & Fixtures</option>
                            <option value="Vehicles & Transportation">Vehicles & Transportation</option>
                            <option value="Machinery & Equipment">Machinery & Equipment</option>
                            <option value="Building & Infrastructure">Building & Infrastructure</option>
                            <option value="Office Supplies & Consumables">Office Supplies & Consumables</option>
                            <option value="Educational & Training Resources">Educational & Training Resources</option>
                            <option value="Library & Learning Resources">Library & Learning Resources</option>
                            <option value="Art, Décor, & Cultural Assets">Art, Décor, & Cultural Assets</option>
                            <option value="Miscellaneous">Miscellaneous</option>
                        </Form.Select> 
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Brand/Model</Form.Label>
                        <Form.Control type="text" ref={brandModel}  />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Serial Number</Form.Label>
                        <Form.Control type="text" ref={serialNumber} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" ref={assetDesc} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Date of Purchase</Form.Label>
                        <Form.Control type="date" ref={dateOfPurchase} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Purchase Price</Form.Label>
                        <Form.Control type="number" ref={purchasePrice} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Current Value</Form.Label>
                        <Form.Control type="text" ref={currentValue} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Assigned to</Form.Label>
                        <Form.Control type="text" ref={assignedTo} />
                    </Form.Group> 

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Assignee Phone Number</Form.Label>
                        <Form.Control type="text" ref={assPhoneNumber} />
                    </Form.Group> 

                </Modal.Body>

                <Modal.Footer>
                    <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
                    <Button variant="primary" id='submitBtn' onClick={addAnAsset} >Submit</Button>
                    <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span> Submitting...</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    const selectedCampus = useRef();
    const assetName = useRef();
    const assetCategory = useRef();
    const brandModel = useRef();
    const assetDesc = useRef();
    const dateOfPurchase = useRef();
    const purchasePrice = useRef();
    const currentValue = useRef();
    const assignedTo = useRef();
    const assPhoneNumber = useRef();
    const serialNumber = useRef();
    

    function addAnAsset() {
        const assetNameValue = assetName.current.value;
        const assetCategoryValue = assetCategory.current.value;
        const brandModelValue = brandModel.current.value;
        const assetDescValue = assetDesc.current.value;
        const dateOfPurchaseValue = dateOfPurchase.current.value;
        const purchasePriceValue = purchasePrice.current.value;
        const currentValueValue = currentValue.current.value;
        const assignedToValue = assignedTo.current.value;
        const assPhoneNumberValue = assPhoneNumber.current.value;
        const selectedCampusValue = selectedCampus.current.value;
        const serialNumberValue = serialNumber.current.value;
    
        // Show spinner and hide submit button
        document.getElementById("submitBtn").style.display = "none";
        document.getElementById("spinnerbtn").style.display = "block";
    
        // Generate new document reference and set document in Firestore
        const newDataRef = doc(collection(db, "AssetRegister"));
        setDoc(newDataRef, {
            assetID: generateAssetID(), // Generate and add Asset ID
            selectedCampus: selectedCampusValue,
            timeStamp: Timestamp.now(),
            assetName: assetNameValue,
            assetCategory: assetCategoryValue,
            brandModel: brandModelValue,
            assetDesc: assetDescValue,
            dateOfPurchase: new Date(dateOfPurchaseValue), // Assuming date input
            purchasePrice: purchasePriceValue,
            currentValue: currentValueValue,
            assignedTo: assignedToValue,
            assPhoneNumber: assPhoneNumberValue,
            docID: newDataRef.id,
            status: "On Service",
            serialNumber:serialNumberValue
        }).then(() => {
            swal("Success!", "Asset added successfully", "success");
            window.location.reload();
        }).catch((error) => {
            swal("Error!", "There was an issue adding the asset: " + error.message, "error");
            document.getElementById("submitBtn").style.display = "block";
            document.getElementById("spinnerbtn").style.display = "none";
        });
    }
    
    function generateAssetID() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
    

    function viewPaymentDetails(docID){

    }

    function viewComments(docID){

    }

  return (
    <div className='teamsComponent'>
        <div className='teamsTopBar'>
            <h5 className='tHide1'>Assets Register</h5>
            <h5 className='tHide2'>Assets Register</h5>
            <button className='startOnlSessBtn' onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faPlus} className="liveSessionIcon" /> Add an Asset
            </button>
            <button className='startOnlSessBtn2' onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faPlus} className="liveSessionIcon" /> Add an Asset
            </button>
        </div>
        <br />


        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Campus</th>
                    <th>Asset Name</th>
                    <th>Category</th>
                    <th>Serial Number</th>
                    <th>Date of Purchase</th>
                    <th>Condition</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {requiLists.map((bill) => ( 
                    <tr key={bill.id}> 
                        <td>{branchMapping[bill.selectedCampus]}</td> 
                        <td>{bill.assetName}</td>  
                        <td>{bill.assetCategory}</td> 
                        <td>{bill.serialNumber}</td> 
                        <td>{new Date(bill.dateOfPurchase.seconds * 1000).toLocaleDateString()}</td> 
                        <td>{bill.status}</td>  
                        <td> 
                            <button 
                                className='btn btn-sm btn-primary' 
                                onClick={() => viewComments(bill.docID)}> 
                                View
                            </button>
                        </td> 
                    </tr>
                ))}
            </tbody>
        </Table>

        <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
    </div>
  )
}


export default AssetRegisterComp